import { replace } from 'ramda'

export type AcquiringOwnerId = string

export type AcquiringItem = {
  id: AcquiringOwnerId //                           идентификатор владельца счета зачисления
  isParentAndAccountOwner: boolean //               родитель и владелец аккаунта
  enabled: boolean //                               разрешено или нет
  ownerType: 'Parent' | 'Student' //                тип владельца счета зачисления
  commissionPercent: number | null //               размер комиссии %
  commissionType: 'increase' | 'decrease' | null // тип комиссии, increase: + к оплате, decrease: - к зачислению
  offerURL: string | null //                        ссылка на оферту
  pageType: 'frame' | 'window' //                   тип страницы, в МП не используется
  balance: number | null //                         текущий баланс
  minSum: number | null //                          минимальная сумма платежа
  maxSum: number | null //                          максимальная сумма платежа
  schoolID: string | null //                        идентификатор школы
  name?: {
    first: string
    last: string
    middle: string
  }
  refillStyle: RefillStyle
}

export enum RefillStyle {
  Common = 'common',
  Recurrent = 'recurrent',
}

export enum RefillType {
  Primary = 'primary', //                           выпуск карт и обслуживание
  Cafeteria = 'cafeteria', //                       пополнение счета столовой
  Camp = 'camp', //                                 пополнение счета лагеря
}

export const isRefillType = (value: any): value is RefillType[keyof RefillType] => {
  return Object.values(RefillType).includes(value)
}

export type AcquiringSettings = {
  primary: Map<string, AcquiringItem>
  cafeteria: Map<string, AcquiringItem>
  camp: Map<string, AcquiringItem>
  availableRefillTypes: Array<RefillType>
}

export enum RefillTarget {
  Self = 'self', // себе
  Child = 'child', // ребенку
}

export const isRefillTarget = (value: any): value is RefillTarget[keyof RefillTarget] => {
  return Object.values(RefillTarget).includes(value)
}

export enum FundSection {
  Refill = 'refill',
  Transfer = 'transfer',
  Success = 'success',
  Fail = 'fail',
}

export const isFundSection = (value: any): value is FundSection[keyof FundSection] => {
  return Object.values(FundSection).includes(value)
}

export enum RefillStep {
  Step1 = 'step1',
  Step2 = 'step2',
  Step3 = 'step3',
  Step4 = 'step4',
  Step5 = 'step5',
}

export const isRefillStep = (value: any): value is RefillStep[keyof RefillStep] => {
  return Object.values(RefillStep).includes(value)
}

export const asStepNumber = (val: RefillStep | null) => {
  if (!val) return 0
  return parseInt(replace(/\D+/g, '', val as string), 10)
}
